import useAppDispatch from "stores/useAppDispatch";
const useViewsDispatch = useAppDispatch;
export default useViewsDispatch;
